"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require("react-bootstrap");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FilterToggle = (_temp2 = _class = function (_Component) {
  _inherits(FilterToggle, _Component);

  function FilterToggle() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FilterToggle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FilterToggle.__proto__ || Object.getPrototypeOf(FilterToggle)).call.apply(_ref, [this].concat(args))), _this), _this.handleOptionSelect = function (query) {
      var pathname = _this.context.location.pathname;

      _this.props.onChange({
        pathname: _this.props.to || pathname,
        query: query
      });
    }, _this.renderOption = function (_ref2, idx) {
      var label = _ref2.label,
          value = _ref2.value;
      var query = _this.context.location.query;
      var param = _this.props.param;

      var newQuery = Object.assign({}, query, _defineProperty({}, param, value));
      var isActive = query[param] === value;
      var className = (0, _classnames2.default)("btn-sm btn-default", { active: isActive });

      return _react2.default.createElement(
        _reactBootstrap.Button,
        {
          className: className,
          key: idx,
          onClick: _this.handleOptionSelect.bind(_this, newQuery) },
        label
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FilterToggle, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          className = _props.className,
          options = _props.options;

      var rootClassName = (0, _classnames2.default)("erg-components-ToggleFilter", className);
      return _react2.default.createElement(
        _reactBootstrap.ButtonGroup,
        { className: rootClassName },
        options.map(this.renderOption.bind(this))
      );
    }
  }], [{
    key: "getDefaultQuery",
    value: function getDefaultQuery(props) {
      return _defineProperty({}, props.param, undefined);
    }
  }, {
    key: "getCurrentQuery",
    value: function getCurrentQuery(props, context) {
      var query = context.location.query;

      return _defineProperty({}, props.param, query[props.param]);
    }
  }]);

  return FilterToggle;
}(_react.Component), _class.displayName = "FilterToggle", _class.contextTypes = {
  location: _propTypes2.default.object.isRequired
}, _class.propTypes = {
  className: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string, // eslint-disable-line react/no-unused-prop-types
    value: _propTypes2.default.oneOfType([// eslint-disable-line react/no-unused-prop-types
    _propTypes2.default.number, _propTypes2.default.string])
  })).isRequired,
  param: _propTypes2.default.string.isRequired,
  to: _propTypes2.default.string
}, _temp2);
exports.default = FilterToggle;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-components-react/lib/filters/ToggleFilter.js
 ** module id = 795
 ** module chunks = 0
 **/